import { SimpleGrid } from "@chakra-ui/react";
import { TrendingUp, Clock, CheckCircle } from "lucide-react";
import { StatCard } from "./StatCard";
import type { OnboardingStats } from "../../../../types/onboarding";

export type StatKey = "em_andamento" | "aguardando" | "aguardando_rh" | "concluidos" | "cancelados";

export interface StatsGridProps {
  stats: OnboardingStats;
  isLoading: boolean;
  showOnly?: StatKey[];
  /** Sobrescreve o rótulo de um card (ex.: "Não Iniciado" no lugar de
   * "Aguardando RH" na tela de Processos RH). */
  labels?: Partial<Record<StatKey, string>>;
  /** Status atualmente filtrado (destaca o card correspondente e esmaece os demais). */
  activeKey?: StatKey | null;
  /** Clicar num card filtra por aquele status; clicar de novo no ativo limpa o filtro. */
  onCardClick?: (key: StatKey) => void;
}

const ALL_CARDS = [
  { key: "em_andamento" as const, label: "Em andamento", bg: "blue.300", icon: TrendingUp },
  { key: "aguardando" as const, label: "Não Iniciado", bg: "yellow.300", icon: Clock },
  { key: "aguardando_rh" as const, label: "Aguardando RH", bg: "orange.300", icon: Clock },
  { key: "concluidos" as const, label: "Concluídos", bg: "green.300", icon: CheckCircle },
  { key: "cancelados" as const, label: "Cancelados", bg: "red.300", icon: Clock },
];

export const StatsGrid = ({ stats, isLoading, showOnly, labels, activeKey, onCardClick }: StatsGridProps) => {
  const cards = showOnly
    ? showOnly
        .map((key) => ALL_CARDS.find((card) => card.key === key))
        .filter((card): card is (typeof ALL_CARDS)[number] => Boolean(card))
    : ALL_CARDS;

  return (
    <SimpleGrid columns={{ base: 2, md: cards.length }} gap={4} mb={6}>
      {cards.map((card) => (
        <StatCard
          key={card.key}
          label={labels?.[card.key] ?? card.label}
          value={stats[card.key]}
          bg={card.bg}
          icon={card.icon}
          isLoading={isLoading}
          isActive={activeKey == null ? undefined : activeKey === card.key}
          onClick={onCardClick && (() => onCardClick(card.key))}
        />
      ))}
    </SimpleGrid>
  );
};

